import { AxiosRequest } from '.';
import { AxiosResponse } from 'axios';
import BackendResponse from '@core/shared/backend-response';
import { HttpCacheableRequest } from './http-cacheable-request';

/**
 * ### HttpGetRequest Module
 *
 * Represent a decorated http `GET Method` with `Authorization` header.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 * @version v1
 */
export abstract class HttpGetRequest<T> extends HttpCacheableRequest {
  protected async dispatch(url: string): Promise<AxiosResponse<BackendResponse<T>>> {
    this.startNewAbortController();
    const response = await AxiosRequest.get<T>(url, { signal: this.controller.signal });
    this.setWasResolved();
    return response;
  }
}
